import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { STORAGE_KEYS } from '../../constants';
import { storage } from '../../utils/storage';
import type { User } from '../../services/authApi';

interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
}

function getStoredUser(): User | null {
  const raw = storage.get(STORAGE_KEYS.USER);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

const initialState: AuthState = {
  user: getStoredUser(),
  token: storage.get(STORAGE_KEYS.AUTH_TOKEN),
  isAuthenticated: !!storage.get(STORAGE_KEYS.AUTH_TOKEN),
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials(state, action: PayloadAction<{ user: User; token: string }>) {
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.isAuthenticated = true;
      storage.set(STORAGE_KEYS.AUTH_TOKEN, action.payload.token);
      storage.set(STORAGE_KEYS.USER, JSON.stringify(action.payload.user));
    },
    logout(state) {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      storage.remove(STORAGE_KEYS.AUTH_TOKEN);
      storage.remove(STORAGE_KEYS.USER);
    },
  },
});

export const { setCredentials, logout } = authSlice.actions;
export default authSlice.reducer;
